define('shared/initializer/form/adapters/mixins/InputValuePersistable',[
    '$',
    'shared/util/state/adapters/form', 
    'shared/util/state', 
    'shared/lib/RSVP'
], function (
    $,
    formAdapter, 
    state, 
    RSVP
) {
    'use strict';

    function Ctor() {
        this.willDoPersistable = true;
    }

    function persistFields($fields, saveAll) {
        var promises = [];
        var me = this;

        $fields.each(function(i, el){
            var $el = $(el);
            var name = $el.attr('name');
            var type = $el.attr('type');
            var value;

            if (saveAll === false) {
                if (
                    type === 'password' && 
                    !me.options.persistPassword
                ) {
                    return;
                }

                if(
                    name !== 'firstname' && 
                    name !== 'UserName' && 
                    name !== 'first_name' && 
                    name !== 'lastname' && 
                    name !== 'last_name'&& 
                    name !== 'email' && 
                    name !== 'telephone' && 
                    name !== 'mobilePhone' && 
                    name !== 'leadtype' && 
                    type !== 'password'
                ){
                    return;
                }
            }

            if (type === 'checkbox') {
                value = $el.prop('checked');
            }
            else {
                value = $el.val();
            }

            promises.push(state.push( 'form.' + name, value ));
        });

        promises.push(state.push( 'form.type', me.type ));

        return RSVP.all(promises);
    }

    Ctor.prototype.doBeforeSubmit = function() {
        var me = this;
        var $form = me.$form;

        return new RSVP.Promise(function( resolve, reject ) {
            var result = {};
            me.emit('beforePersistable', result);

            RSVP.resolve()
                .then(function(){
                    return result.promise;
                })
                .then(function(){
                    return state.adapters.add(formAdapter);    
                })
                .then(function(){
                    var $fields = $form.find('select, input');

                    if(
                        me.type === 'creditcard' || 
                        me.type === 'existingcreditcard' || 
                        me.type === 'paypal' || 
                        me.type === 'directdebit' || 
                        me.type === 'worldpay'
                    ) {
                        return RSVP.resolve();
                    }
                    else if (
                        me.type === 'generic' 
                    ) {
                        return persistFields.call(me, $fields, true);
                    }
                    else{
                        return persistFields.call(me, $fields, false);
                    }
                }, reject)
                .then(resolve, reject);

        });
        
    };

    return Ctor;
});
